import { render, staticRenderFns } from "./UserNote.vue?vue&type=template&id=9a04fc0c&scoped=true&"
import script from "./UserNote.vue?vue&type=script&lang=js&"
export * from "./UserNote.vue?vue&type=script&lang=js&"
import style0 from "./UserNote.vue?vue&type=style&index=0&id=9a04fc0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a04fc0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
